/**
 * @description renders the Knowledge Center Entry dialog
 */

import React from 'react';
import { PropTypes } from 'prop-types';
import Box from '@mui/material/Box';
import Close from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Slide from '@mui/material/Slide';

import KnowledgeDialogForm from './KnowledgeDialogForm';
import { ADMIN_MODE } from '../constants';

// Defines a slide up transition component
const Transition = React.forwardRef(
  (props, ref) => (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <Slide direction='up' ref={ref} {...props} />
  )
);

const styles = {
  closeBtn: {
    mr: 2
  },
  header: {
    alignItems: 'center',
    borderBottom: 1,
    borderColor: 'grey.400',
    display: 'flex',
    flexWrap: 'nowrap',
    justifyContent: 'space-between',
    width: '100%'
  }
};

/**
 * @prop {string} knowledgeId - indicates the knowledge entry id to be loaded in the dialog
 * @prop {string} mode - indicates which mode the dialog is in
 * @prop {() => void} onClose - callback function when the dialog should be closed
 * @prop {(data: object) => void} onSubmit - callback function when the dialog form is submitted. It takes the form data as
 *  a parameter
 * @prop {boolean} open - indicates if the dialog is open or not
 */
const KnowledgeDialog = ({
  knowledgeId,
  mode,
  onClose,
  onSubmit,
  open
}) => (
  <Dialog
    open={open}
    TransitionComponent={Transition}
    keepMounted
    onClose={() => onClose()}
    fullWidth
    maxWidth='sm'
  >
    {/* Don't render the dialog content while its closed */}
    {open ? (
      <>
        <Box sx={styles.header}>
          <DialogTitle>
            {mode === ADMIN_MODE.EDIT ? 'Update' : 'Add'} Knowledge Center Entry
          </DialogTitle>
          <IconButton onClick={() => onClose()} sx={styles.closeBtn}>
            <Close />
          </IconButton>
        </Box>
        <KnowledgeDialogForm
          knowledgeId={knowledgeId}
          mode={mode}
          onClose={() => onClose()}
          onSubmit={(data) => onSubmit(data)}
        />
      </>
    ) : null}
  </Dialog>
);

KnowledgeDialog.propTypes = {
  mode: PropTypes.string,
  knowledgeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired
};

KnowledgeDialog.defaultProps = {
  knowledgeId: null,
  mode: ADMIN_MODE.ADD
};

export default KnowledgeDialog;
